import React from 'react';

import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemIcon, ListSubheader } from '@material-ui/core';
import {
  BusinessRounded as Business,
  DashboardRounded as Dashboard,
  LinearScaleRounded as LinearScale,
  ShoppingBasketRounded as ShoppingBasket,
  StoreRounded as Store,
  AssessmentRounded as Assessment,
  ShowChartRounded as ShowChart,
  SpaRounded as Spa,
  LabelRounded as Label,
  LocalAtmRounded as LocalAtm,
  ShoppingCartRounded as ShoppingCart,
  InfoRounded as Info,
  ArchiveRounded as Archive,
  ReceiptRounded as Receipt,
  LoyaltyRounded as Loyalty,
  InsertInvitationRounded as Invitation,
  CardMembershipRounded as CardMembership,
  LocationCityRounded as LocationCity,
  LocationOnRounded as LocationOn,
  FilterNoneRounded as FilterNone,
  ViewCarouselRounded as ViewCarousel,
  SpeedRounded as Speed,
  PersonRounded as Person,
  GroupRounded as Group,
  LocalFloristRounded as LocalFlorist,
  BookmarkRounded as Bookmark,
  BookmarksRounded as Bookmarks,
} from '@material-ui/icons';
import { ADMIN_STATISTICS_V2_APP_PATHS } from '../../statistics/constants/path.constants';
import { ADMIN_USERS_APP_PATHS } from '../../../users/constants/users-paths.constants';
import { ADMIN_DELIVERY_POINT_APP_PATHS } from '../../../delivery-points/constants/delivery-points-app-paths.constants';
import { ADMIN_ORGANIZATIONS_APP_PATHS } from '../../../organizations/constants/organizations-paths.constants';
import { ADMIN_SEGMENTS_APP_PATHS } from '../../../segments/constants/segments-app-paths.constants';
import { ADMIN_PRODUCTS_APP_PATHS } from '../../../products/constants/products-app-paths.constants';
import { ADMIN_BASKETS_APP_PATHS } from '../../../baskets/constants/baskets-app-paths.constants';
import { ADMIN_CATEGORIES_APP_PATHS } from '../../../categories/constants/categories-app-paths.constants';
import { ADMIN_SUBCATEGORIES_APP_PATHS } from '../../../subcategories/constants/subcategories-app-paths.constants';
import { ADMIN_TAXES_APP_PATHS } from '../../../taxes/constants/taxes-app-paths.constants';
import { ADMIN_ORDER_V2_APP_PATHS } from '../../../orders/constants/orders-app-paths.constant';
import { ADMIN_WEIGHT_UNITIES_APP_PATHS } from '../../../weight-unities/constants/weight-unities-app-paths.constants';
import { ADMIN_TAGS_APP_PATHS } from '../../../tags/constants/tags-app-paths.constants';
import { ADMIN_INVITATIONS_APP_PATHS } from '../../../invitations/constants/invitations-app-paths.constants';
import { ADMIN_DELIVERY_ZONES_APP_PATHS } from '../../../delivery-zones/constants/delivery-zones-app-paths.constants';
import { ADMIN_DELIVERY_CITIES_APP_PATHS } from '../../../delivery-cities/constants/delivery-cities-app-paths.constants';

interface MenuItem {
  id: string;
  icon: React.ReactNode;
  label: string;
  path: string;
  disabled?: boolean;
}

interface MenuList {
  id: string;
  listHeader: string;
  items: MenuItem[];
}

const MENU_LISTS: MenuList[] = [
  {
    id: 'statistics',
    listHeader: 'Statistiques',
    items: [
      {
        id: 'statistics-overview',
        icon: <Dashboard />,
        label: 'Dashboard',
        path: ADMIN_STATISTICS_V2_APP_PATHS.OVERVIEW,
      },
      {
        id: 'statistics-commissions',
        disabled: true,
        icon: <Assessment />,
        label: 'Commissions',
        path: ADMIN_STATISTICS_V2_APP_PATHS.COMMISSIONS,
      },
      {
        id: 'statistics-sales',
        disabled: true,
        icon: <ShowChart />,
        label: 'Ventes',
        path: ADMIN_STATISTICS_V2_APP_PATHS.SALES,
      },
    ],
  },
  {
    id: 'clients',
    listHeader: 'Clients',
    items: [
      {
        id: 'clients-users',
        icon: <Person />,
        label: 'Utilisateurs',
        path: ADMIN_USERS_APP_PATHS.USERS_LIST,
      },
      {
        id: 'clients-organizations',
        icon: <Business />,
        label: 'Organisations',
        path: ADMIN_ORGANIZATIONS_APP_PATHS.ORGANIZATIONS_LIST,
      },
      {
        id: 'clients-segments',
        icon: <LinearScale />,
        label: 'Segments',
        path: ADMIN_SEGMENTS_APP_PATHS.SEGMENTS_LIST,
      },
    ],
  },
  {
    id: 'delivery',
    listHeader: 'Livraison',
    items: [
      {
        id: 'delivery-cities',
        icon: <LocationCity />,
        label: 'Villes de livraison',
        path: ADMIN_DELIVERY_CITIES_APP_PATHS.DELIVERY_CITIES_LIST,
      },
      {
        id: 'delivery-points',
        icon: <Store />,
        label: 'Points de livraison',
        path: ADMIN_DELIVERY_POINT_APP_PATHS.DELIVERY_POINTS_LIST,
      },
      {
        id: 'delivery-zones',
        icon: <LocationOn />,
        label: 'Zones de livraison',
        path: ADMIN_DELIVERY_ZONES_APP_PATHS.DELIVERY_ZONES_LIST,
      },
    ],
  },
  {
    id: 'sales',
    listHeader: 'Ventes',
    items: [
      {
        id: 'sales-infos',
        disabled: true,
        icon: <Info />,
        label: 'Informations du jour',
        path: '/admin-v2/daily-information',
      },
      {
        id: 'sales-orders-to-archive',
        icon: <Archive />,
        label: 'Commandes à archiver',
        path: ADMIN_ORDER_V2_APP_PATHS.ARCHIVE_ORDER,
      },
      {
        id: 'sales-orders',
        icon: <ShoppingCart />,
        label: 'Commandes',
        path: ADMIN_ORDER_V2_APP_PATHS.ORDERS_OVERVIEW,
      },
      {
        id: 'sales-orders-delivery-notes',
        icon: <Receipt />,
        label: 'Bons de livraison',
        path: ADMIN_ORDER_V2_APP_PATHS.DELIVERY_NOTES_LIST,
      },
      {
        id: 'sales-invitations',
        icon: <Invitation />,
        label: 'Invitations éco',
        path: ADMIN_INVITATIONS_APP_PATHS.INVITATIONS_LIST,
      },
      {
        id: 'sales-orders-discounts',
        disabled: true,
        icon: <Loyalty />,
        label: 'Promotions',
        path: '/admin-v2/discount',
      },
      {
        id: 'sales-subscriptions',
        disabled: true,
        icon: <CardMembership />,
        label: 'Abonnements',
        path: '/admin-v2/subscriptions',
      },
    ],
  },
  {
    id: 'catalogs',
    listHeader: 'Catalogue',
    items: [
      {
        id: 'catalogs-products',
        icon: <Spa />,
        label: 'Produits',
        path: ADMIN_PRODUCTS_APP_PATHS.PRODUCTS_LIST,
      },
      {
        id: 'catalogs-baskets',
        icon: <ShoppingBasket />,
        label: 'Paniers',
        path: ADMIN_BASKETS_APP_PATHS.BASKETS_LIST,
      },
      {
        id: 'catalogs-categories',
        icon: <Bookmark />,
        label: 'Rubriques',
        path: ADMIN_CATEGORIES_APP_PATHS.CATEGORIES_LIST,
      },
      {
        id: 'catalogs-subcategories',
        icon: <Bookmarks />,
        label: 'Sous-rubriques',
        path: ADMIN_SUBCATEGORIES_APP_PATHS.SUBCATEGORIES_LIST,
      },
      {
        id: 'catalogs-taxes',
        icon: <LocalAtm />,
        label: 'Taxes',
        path: ADMIN_TAXES_APP_PATHS.TAXES_LIST,
      },
    ],
  },
  {
    id: 'settings',
    listHeader: 'Paramètres',
    items: [
      {
        id: 'settings-popup',
        disabled: true,
        icon: <FilterNone />,
        label: 'Popup',
        path: '/admin-v2/banners',
      },
      {
        id: 'settings-home-banner',
        disabled: true,
        icon: <ViewCarousel />,
        label: 'Bannière Home',
        path: '/admin-v2/pageHome',
      },
      {
        id: 'settings-weight-units',
        icon: <Speed />,
        label: 'Unités de poids',
        path: ADMIN_WEIGHT_UNITIES_APP_PATHS.WEIGHT_UNITIES_LIST,
      },
      {
        id: 'settings-tags',
        icon: <Label />,
        label: 'Tags',
        path: ADMIN_TAGS_APP_PATHS.TAGS_LIST,
      },
      {
        id: 'settings-teams',
        disabled: true,
        icon: <Group />,
        label: 'Équipes',
        path: '/admin-v2/teams',
      },
      {
        id: 'settings-producers',
        disabled: true,
        icon: <LocalFlorist />,
        label: 'Producteurs',
        path: '/admin-v2/producers',
      },
    ],
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '50px',
    height: '98svh',
    overflow: 'scroll',
    scrollbarColor: 'transparent transparent',

    '& > .MuiListSubheader-root': {
      color: '#9DB2BF',
    },
  },
  menuItem: {
    color: '#FFF',
    borderRadius: '5px',
    marginBottom: '5px',
    '&:hover': {
      backgroundColor: `${theme.palette.admin.primary.light}33`,
    },

    '& > .MuiListItemIcon-root': {
      color: '#FFF',
      minWidth: '40px',
    },
  },
  activeMenuItem: {
    backgroundColor: theme.palette.admin.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
}));

export default function AdminMenuList({ currentPath }: { currentPath: string }) {
  const classes = useStyles();

  // Only the menu item with the longest matching path prefix is active, so
  // /admin-v2/orders/to-archive highlights "Archivage" without also lighting up "Commandes".
  const matchesPath = (itemPath: string) => currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);

  const activePath = MENU_LISTS.flatMap((list) => list.items)
    .filter((item) => matchesPath(item.path))
    .reduce<string | null>((longest, item) => (item.path.length > (longest?.length ?? 0) ? item.path : longest), null);

  return (
    <List component="nav" className={classes.root}>
      {MENU_LISTS.map((list) => (
        <React.Fragment key={list.id}>
          <ListSubheader disableSticky={true} component="div">
            {list.listHeader}
          </ListSubheader>
          {list.items.map((item) => (
            <ListItem
              className={clsx(classes.menuItem, item.path === activePath && classes.activeMenuItem)}
              button
              component={Link}
              to={item.path}
              key={item.id}
              disabled={item.disabled}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              {item.label}
            </ListItem>
          ))}
        </React.Fragment>
      ))}
    </List>
  );
}
